import { SettingItem } from '@/features/ai_agents_setting/components/Common';
import { useTranslation } from '@/i18n';
import { FormCheckbox, TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  isEditMode: boolean;
  name: string;
  detailLink?: string;
};

export const PaymentRequestSupportAgentService: FC<Props> = ({
  isEditMode,
  name,
  detailLink,
}) => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext();
  const isEnabled = watch(name);

  if (isEditMode) {
    return (
      <SettingItem
        label={
          <>
            {t('ai_agents_setting_payment_request_support_service_title')}
            <br />
            {t('ai_agents_setting_payment_request_support_service_subtitle')}
          </>
        }
        value={
          <div className={cx('serviceValueContent')}>
            <FormCheckbox
              name={name}
              control={control}
              inputId={name}
              label={t('use')}
              className={cx('serviceCheckboxLabel')}
            />
            <div className={cx('serviceDescription')}>
              <span>
                {t('ai_agents_setting_invoice_receipt_description_prefix')}
              </span>
              {detailLink && (
                <TextLink href={detailLink} target='_blank'>
                  {t('ai_agents_setting_detail_link')}
                </TextLink>
              )}
            </div>
          </div>
        }
      />
    );
  }

  return (
    <SettingItem
      label={
        <>
          {t('ai_agents_setting_payment_request_support_service_title')}
          <br />
          {t('ai_agents_setting_payment_request_support_service_subtitle')}
        </>
      }
      value={
        <div className={cx('serviceValueContent')}>
          <span className={cx('serviceValueContentText')}>
            {t(isEnabled ? 'use' : 'not_use')}
          </span>
          <div className={cx('serviceDescription')}>
            <span>
              {t('ai_agents_setting_invoice_receipt_description_prefix')}
            </span>
            {detailLink && (
              <TextLink href={detailLink} target='_blank'>
                {t('ai_agents_setting_detail_link')}
              </TextLink>
            )}
          </div>
        </div>
      }
    />
  );
};

PaymentRequestSupportAgentService.displayName =
  'PaymentRequestSupportAgentService';
